// Texty lightboxu galerie produktu — slovenské dvojče locale/cs/galleryLightbox.js.
import { NBSP } from '../../modules/money.js';

export default {
  dialog: 'Galéria produktu',
  close: 'Zavrieť galériu',
  prev: 'Predchádzajúca fotka',
  next: 'Ďalšia fotka',
  cart: 'Do košíka',
  allPhotos: 'Všetky fotky',
  back: 'Späť na detail produktu',
  photo: 'Fotka',
  hint: 'Ťahaním posúvate · double-tap späť na 1' + NBSP + '×',
};
